module.exports = __webpack_public_path__ + "img/mit.ce78f455.jpg";